// import axios from 'axios'
// import { useState } from 'react'
// import { Link, useNavigate } from 'react-router-dom'
// import { Eye, EyeOff, UserPlus } from 'lucide-react'
// import { useAuthStore } from '../../stores/authStore'
// import { authApi } from '../../lib/api/auth'
// import './auth.css'

// interface SignUpForm {
//   name: string
//   email: string
//   password: string
//   confirmPassword: string
// }   FFF

// export default function SignUp() {
//   const navigate = useNavigate()
//   const { logout } = useAuthStore()

//   const [form, setForm] = useState<SignUpForm>({
//     name: '',
//     email: '',
//     password: '',
//     confirmPassword: '',
//   })

//   const [showPassword, setShowPassword] = useState(false)
//   const [error, setError] = useState('')
//   const [loading, setLoading] = useState(false)

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setForm({ ...form, [e.target.name]: e.target.value })
//   }

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault()
//     setError('')

//     if (form.password !== form.confirmPassword) {
//       setError('Passwords do not match')
//       return
//     }

//     if (form.password.length < 6) {
//       setError('Password must be at least 6 characters')
//       return
//     }

//     setLoading(true)

//     try {
//       // Register user
//       await authApi.register(form.name, form.email, form.password, 'client')

//       /**
//        * Important: Ensure user is NOT logged in after registration
//        */
//       localStorage.removeItem('token')
//       localStorage.removeItem('user')

//       logout()

//       // Redirect to login page
//       navigate('/signin', {
//         replace: true,
//         state: { registered: true },
//       })

//     } catch (err: unknown) {
//       if (axios.isAxiosError(err) && err.response?.data?.message) {
//         setError(err.response.data.message)
//       } else {
//         setError(err instanceof Error ? err.message : 'Registration failed')
//       }
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <div className="auth-page">
//       <div className="auth-container">

//         {/* LEFT PANEL */}
//         <div className="auth-left">
//           <div className="auth-brand">
//             <Link to="/">
//               <img
//                 src="/InterviewDressRehearsal_LOGO.png"
//                 alt="IDR"
//                 className="auth-logo"
//               />
//             </Link>

//             <h1>Interview Dress Rehearsal</h1>
//             <p>
//               Join thousands of professionals who have improved their interview
//               skills with us.
//             </p>
//           </div>
//         </div>

//         {/* RIGHT PANEL */}
//         <div className="auth-right">
//           <div className="auth-card">

//             <div className="auth-header">
//               <h2>Create account</h2>
//               <p>Get started with Interview Dress Rehearsal</p>
//             </div>

//             {error && <div className="auth-error">{error}</div>}

//             <form onSubmit={handleSubmit} className="auth-form">

//               {/* NAME */}
//               <div className="form-group">
//                 <label className="form-label">Full name</label>
//                 <input
//                   type="text"
//                   name="name"
//                   className="form-input"
//                   placeholder="Enter your full name"
//                   value={form.name}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               {/* EMAIL */}
//               <div className="form-group">
//                 <label className="form-label">Email address</label>
//                 <input
//                   type="email"
//                   name="email"
//                   className="form-input"
//                   placeholder="Enter your email"
//                   value={form.email}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               {/* PASSWORD */}
//               <div className="form-group">
//                 <label className="form-label">Password</label>

//                 <div className="password-input">
//                   <input
//                     type={showPassword ? 'text' : 'password'}
//                     name="password"
//                     className="form-input"
//                     placeholder="Create a password"
//                     value={form.password}
//                     onChange={handleChange}
//                     required
//                   />

//                   <button
//                     type="button"
//                     className="password-toggle"
//                     onClick={() => setShowPassword(!showPassword)}
//                   >
//                     {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>
//               </div>

//               {/* CONFIRM PASSWORD */}
//               <div className="form-group">
//                 <label className="form-label">Confirm password</label>
//                 <input
//                   type="password"
//                   name="confirmPassword"
//                   className="form-input"
//                   placeholder="Confirm your password"
//                   value={form.confirmPassword}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               {/* TERMS */}
//               <div className="form-options">
//                 <label className="checkbox-label">
//                   <input type="checkbox" required />
//                   <span>
//                     I agree to the Terms of Service and Privacy Policy
//                   </span>
//                 </label>
//               </div>

//               {/* SUBMIT */}
//               <button
//                 type="submit"
//                 className="btn btn-primary auth-submit"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   'Creating account...'
//                 ) : (
//                   <>
//                     <UserPlus size={18} /> Create Account
//                   </>
//                 )}
//               </button>
//             </form>

//             <div className="auth-footer">
//               <p>
//                 Already have an account? <Link to="/signin">Sign in</Link>
//               </p>
//             </div>

//           </div>
//         </div>

//       </div>
//     </div>
//   )
// }

import axios from 'axios'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Eye, EyeOff, UserPlus } from 'lucide-react'
import { useAuthStore } from '../../stores/authStore'
import { authApi } from '../../lib/api/auth'
import './auth.css'

interface SignUpForm {
  name: string
  email: string
  password: string
  confirmPassword: string
}

export default function SignUp() {
  const navigate = useNavigate()
  const { logout } = useAuthStore()

  const [form, setForm]                 = useState<SignUpForm>({ name: '', email: '', password: '', confirmPassword: '' })
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError]               = useState('')
  const [loading, setLoading]           = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match')
      return
    }
    if (form.password.length < 6) {
      setError('Password must be at least 6 characters')
      return
    }

    setLoading(true)
    try {
      await authApi.register(form.name, form.email, form.password, 'client')
      // Clear any existing session so PublicAuthRoute does not redirect away from /signin
      logout()
      navigate('/signin', { replace: true, state: { registered: true } })
    } catch (err: unknown) {
      if (axios.isAxiosError(err) && err.response?.data?.message) {
        setError(err.response.data.message)
      } else {
        setError(err instanceof Error ? err.message : 'Registration failed')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-container">

        {/* ── Left panel ── */}
        <div className="auth-left">
          <div className="auth-brand">
            <Link to="/"><img src="/InterviewDressRehearsal_LOGO.png" alt="IDR" className="auth-logo" /></Link>
            <h1>Interview Dress Rehearsal</h1>
            <p>Join thousands of professionals who have improved their interview skills with us.</p>
          </div>

          <div className="auth-features">
            {[
              { icon: 'clock',  label: 'Flexible scheduling' },
              { icon: 'users',  label: 'Experienced interviewers' },
              { icon: 'file',   label: 'Detailed feedback reports' },
            ].map(({ label }) => (
              <div key={label} className="feature-item">
                <div className="feature-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22,4 12,14.01 9,11.01" />
                  </svg>
                </div>
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ── Right panel ── */}
        <div className="auth-right">
          <div className="auth-card">
            <div className="auth-header">
              <h2>Create account</h2>
              <p>Get started with Interview Dress Rehearsal</p>
            </div>

            {error && <div className="auth-error">{error}</div>}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label className="form-label">Full name</label>
                <input
                  type="text"
                  name="name"
                  className="form-input"
                  placeholder="Enter your full name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Email address</label>
                <input
                  type="email"
                  name="email"
                  className="form-input"
                  placeholder="Enter your email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Password</label>
                <div className="password-input">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    className="form-input"
                    placeholder="Create a password (min. 6 characters)"
                    value={form.password}
                    onChange={handleChange}
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Confirm password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  className="form-input"
                  placeholder="Confirm your password"
                  value={form.confirmPassword}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-options">
                <label className="checkbox-label">
                  <input type="checkbox" required />
                  <span>I agree to the Terms of Service and Privacy Policy</span>
                </label>
              </div>

              <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
                {loading ? 'Creating account…' : <><UserPlus size={18} /> Create Account</>}
              </button>
            </form>

            <div className="auth-footer">
              <p>Already have an account? <Link to="/signin">Sign in</Link></p>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}
